<template>
  <div class="e-chart" :id="id"></div>
</template>

<script>
import * as echarts from 'echarts/core';
export default {
  name: 'EChart',
  props: {
    config: {
      type: Object,
      require: true
    }
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.renderChart()
      }
    }
  },
  data() {
    return {
      id: undefined
    }
  },
  methods: {
    renderChart() {
      if (!this.config || !Object.keys(this.config).length) {
        setTimeout(() => {
          this.renderChart()
        }, 200)
      } else {
        this.initInstance(this.config);
      }
    },
    initInstance(option) {
      let chart = echarts.getInstanceByDom(
        document.getElementById(this.id)
      );

      if (chart) {
        chart.setOption(option);
      } else {
        chart = echarts.init(document.getElementById(this.id));
        chart.setOption(option);
      }
    },
    generateId() {
      this.id = this.$utils.randomString()
    },
  },
  created() {
    this.generateId()
  },
  mounted() {
    this.renderChart()
  }
}
</script>

<style lang="less" scoped>
  .e-chart {
    width: 100%;
    height: 1400px;
    padding: 40px 0;
    border-radius: 6px;
    background-color: rgba(255, 255, 255, 0.3);
  }
</style>